import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IconButtonComponent } from '../button/components/icon-button/icon-button.component';
import { GroupComponent } from '../group/group.component';

@Component({
  selector: 'rt-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GroupComponent, IconButtonComponent],
})
export class PaginationComponent {
  @Input() public page: number;
  @Input() public pagesCount: number;
  @Input() public prevPageDisabled: boolean = false;
  @Input() public nextPageDisabled: boolean = false;
  @Output() public pageChange: EventEmitter<number> = new EventEmitter();

  private _canGoToPrevPage: boolean;
  private _canGoToNextPage: boolean;

  // Deprecated; use pagesCount or prevPageDisabled instead
  @Input()
  public set canGoToPrevPage(canGoToPrevPage: boolean) {
    this._canGoToPrevPage = canGoToPrevPage;
  }

  public get canGoToPrevPage(): boolean {
    return this._canGoToPrevPage !== undefined
      ? this._canGoToPrevPage
      : !this.prevPageDisabled && this.page > 1;
  }

  // Deprecated; use pagesCount or nextPageDisabled instead
  @Input()
  public set canGoToNextPage(canGoToNextPage: boolean) {
    this._canGoToNextPage = canGoToNextPage;
  }

  public get canGoToNextPage(): boolean {
    return this._canGoToNextPage !== undefined
      ? this._canGoToNextPage
      : !this.nextPageDisabled && this.page < this.pagesCount;
  }
}
